export default __webpack_public_path__ + "static/media/649.5430f879.gif";